export default [
    {
        fieldType: 'boundary',
        description: ''
    },
    {
        fieldType: 'short_answer',
        description: 'You can enter alpha-numeric text into short answer fields like this one.'
    },
    {
        fieldType: 'date',
        description: 'Date fields let you enter a date.'
    },
    {
        fieldType: 'number',
        description: 'Number fields let you enter a number.'
    },
    {
        fieldType: 'file_upload',
        description: 'You can upload files using the upload field.'
    },
    {
        fieldType: 'dropdown',
        description: 'Picking one option out of many can be done through a dropdown.'
    },
    {
        fieldType: 'poi',
        description: 'Mark notable locations using the point of interest field.'
    },
    {
        fieldType: 'single_choice',
        description: 'Single selection fields let you quickly pick an option when there are a few available.'
    },
    {
        fieldType: 'multiple_choice',
        description: 'Multiple choice field allows you to select multiple options.'
    },
    {
        fieldType: 'paragraph',
        description: 'Paragraph fields let you enter a lot of alpha-numeric text, ideal for notes and descriptions.'
    },
    {
        fieldType: 'checkbox',
        description: 'Checkboxes in a multi-select field let you pick one or more relevant options.'
    },
    {
        fieldType: 'slider',
        description: 'Slider field allows you to select from a range of data.'
    },
    {
        fieldType: 'tab_choice',
        description: 'Tab choices allows you to select a tab.'
    },
    {
        fieldType: 'radio',
        description: 'Radio button allows you to select one value.'
    },
    {
        fieldType: 'time',
        description: 'Time field allows you to select a time.'
    },
    {
        fieldType: 'email',
        description: 'Email field allows you to enter an email address.'
    },
    {
        fieldType: 'phone_number',
        description: 'Phone number field allows you to enter a phone number.'
    },

    // add new field type here
]